import Agent from './Agent';
import {
  type AgentSuggestions,
  type AgentParams,
  type AgentInstances,
} from './Agent';

class WhiteboardAgent extends Agent {
  static name = 'WhiteboardAgent';

  static publicName = 'Whiteboard';

  static available(
    _agentParams: AgentParams,
    agentInstances: AgentInstances
  ): boolean {
    return !!(
      window.currentAccount?.hasGeneralAiAssistant &&
      window.featureFlags.awt_390_whiteboard_ai_assistant &&
      agentInstances.assistedWhiteboard
    );
  }

  isReasoningEnabledByDefault(): boolean {
    return true;
  }

  getSuggestions(): AgentSuggestions {
    return [
      {
        title: 'Create',
        prompt:
          'Tell me what type of whiteboard you want to create. You can add use cases and even refer to existing Aha! records by their IDs.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to create a whiteboard for me.\n\nLet's start...\n\nI want to create a whiteboard that: `,
        icon: 'refine',
      },
      {
        title: 'Organize',
        prompt:
          'Tell me how you want to organize the shapes on this whiteboard. You can add themes or categories you wish to group them by.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to arrange shapes on my whiteboard.\n\nLet's start...\n\nI want to organize my whiteboard by: `,
        icon: 'refine',
      },
      {
        title: 'Summarize',
        prompt: 'Tell me what aspects of the whiteboard you want to summarize.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to summarize the content of my whiteboard.\n\nLet's start...\n\nPlease summarize: `,
        icon: 'summarize',
      },
    ];
  }
}

Agent.register(WhiteboardAgent);

export default WhiteboardAgent;
